/* eslint-disable */

/** A message shown at the top of the limits page */
export interface LimitsPageletInlineMessage {
  /** The icon shown above the text */
  icon?: LimitsPageletInlineMessageIcon;
  /** The main text shown in bold. This should always be present */
  main_text?: string;
  /** Subtext shown underneath the main_text */
  subtext?: string;
  /** Button to show beneath the subtext or main_text. If primary and secondary button are non null, primary is right of secondary */
  primary_button?: LimitsPageletInlineMessageButton;
  /** Button to show to the left of primary_button */
  secondary_button?: LimitsPageletInlineMessageButton;
  /** An identifier - set to current timestamp at time of creation */
  version?: number;
}

export enum LimitsPageletInlineMessageIcon {
  /** VERIFYING - Green shield with lock outline inside */
  VERIFYING = "VERIFYING",
  /** DECREASE - Red circle with downward pointed arrow inside */
  DECREASE = "DECREASE",
  /** FAILED - Red circle with 'X' inside */
  FAILED = "FAILED",
  /** ALERT - Red circle with '!' inside */
  ALERT = "ALERT",
}

/** A generic button used in the LimitsPageletInlineMessage */
export interface LimitsPageletInlineMessageButton {
  /** Message shown on the button. The color is cash green */
  text?: string;
  /** Action if the button is pressed */
  button_action?: LimitsPageletInlineMessageButtonButtonAction;
  /** The client link for the action. If button_action is OPEN_URL, this must be nonnull */
  url_to_open?: string;
}

export enum LimitsPageletInlineMessageButtonButtonAction {
  OPEN_URL = "OPEN_URL",
  DISMISS = "DISMISS",
}
